import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import { useOutsideClick } from "@common/hooks/outsideClick";

import { tooltipDirectionMap } from "./helpers";

import "./style.scss";

const SimpleDropDown = ({ header, children, className, onClose, onOpen, enableIcon = true, setIsOpen = () => { }, ...rest }) => {
	const [_openSection, setOpenSection] = useState(rest.openSection || false);
	const openSection = "openSection" in rest ? rest.openSection : _openSection;
	const [openDirection, setOpenDirection] = useState("");

	const wrapperRef = useOutsideClick(() => {
		setOpenDirection(null);
		setOpenSection(false);
		onClose()
	}, []);

	const tooltipRef = useRef(null);

	const calculateDirection = () => {
		const bounding = tooltipRef.current?.getBoundingClientRect() || 0;

		const [direction] = Object.entries(tooltipDirectionMap).find(([, checker]) => checker(bounding)) || [
			"upRight",
		];

		setOpenDirection(direction);
	};
	const headerClick = e => {
		calculateDirection();
		e.stopPropagation();

		if (openSection) onClose();
		else onOpen?.()
		setOpenSection(!openSection);
	};
	setIsOpen(openSection);

	return (
		<div
			className={classnames(`t-d-container t-d-wrapper ${className}`, { "is-open": openSection })}
			ref={wrapperRef}
			onClick={headerClick}
		>
			{enableIcon && <i className={`global-icon icon-gear-settings settings-icon`} />}
			<div
				className={classnames("t-d-header", { "t-d-active-state": openSection })}

				ref={tooltipRef}
			>
				{header}
			</div>

			{openSection && (
				<div className={`t-d-wrapper-section t-d-active-${openDirection}`}>
					<div className="t-d-section-inner-container" onClick={e => e.stopPropagation()}>
						{children}
					</div>
				</div>
			)}
		</div>
	);
};

SimpleDropDown.propTypes = {
	header: PropTypes.node,
	openSection: PropTypes.bool,
	onToggle: PropTypes.func,
	className: PropTypes.string,
	children: PropTypes.node,
	onClose: PropTypes.func,
	onOpen: PropTypes.func
};

export default SimpleDropDown;
